import type { ReadonlyURLSearchParams } from 'next/navigation';

export function createQueryString(
  key: string,
  value: string,
  searchParams: ReadonlyURLSearchParams | URLSearchParams,
) {
  const params = new URLSearchParams(searchParams.toString());

  if (!value) {
    params.delete(key);
  } else {
    params.set(key, `${value}`);
  }

  return params.toString();
};
